import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Application } from '@enums/application.enums';

export interface MinimizedPlayerState {
  isMinimized: boolean;
  currentMusic: any;
  musicList: any[];
  currentIndex: number;
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  audioElement: HTMLAudioElement | null;
  initialState?: any;
  isLocked?: boolean;
  playSessionId?: string;
  playLastRecordedTime?: number;
}

@Injectable({
  providedIn: 'root'
})
export class MinimizedPlayerService {
  private initialState: MinimizedPlayerState = {
    isMinimized: false,
    currentMusic: null,
    musicList: [],
    currentIndex: 0,
    isPlaying: false,
    currentTime: 0,
    duration: 0,
    audioElement: null,
    initialState: null,
    isLocked: false
  };

  private stateSubject = new BehaviorSubject<MinimizedPlayerState>(
    this.initialState
  );
  public state$: Observable<MinimizedPlayerState> =
    this.stateSubject.asObservable();
  public updateCurrentSongSubject = new Subject<any>();

  minimize(
    music: any,
    musicList: any[],
    currentIndex: number,
    audioElement: HTMLAudioElement | null,
    isPlaying: boolean,
    currentTime: number,
    duration: number,
    initialState?: any,
    playSessionId?: string,
    playLastRecordedTime?: number
  ): void {
    this.stateSubject.next({
      isMinimized: true,
      currentMusic: music,
      musicList,
      currentIndex,
      isPlaying,
      currentTime,
      duration,
      audioElement,
      initialState,
      playSessionId,
      playLastRecordedTime
    });
  }

  maximize(): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      isMinimized: false
    });
  }

  updateState(updates: Partial<MinimizedPlayerState>): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      ...updates
    });
  }

  updateCurrentSong(
    musicList: any[],
    currentIndex: number,
    initialState?: any
  ): void {
    const currentState = this.stateSubject.value;
    if (
      currentState.isMinimized &&
      musicList.length > Application.ZERO &&
      currentIndex >= Application.ZERO &&
      currentIndex < musicList.length
    ) {
      const currentMusic = musicList[currentIndex];
      if (currentMusic) {
        this.updateCurrentSongSubject.next({
          ...currentState,
          currentMusic,
          musicList,
          currentIndex,
          isPlaying: false,
          currentTime: Application.ZERO,
          duration: Application.ZERO,
          initialState: initialState || currentState.initialState
        });
      }
    }
  }

  getState(): MinimizedPlayerState {
    return this.stateSubject.value;
  }

  clear(): void {
    this.stateSubject.next(this.initialState);
  }
}
